import { useState, useCallback } from 'react';

/**
 * Edit apply/dismiss flow for widget edits.
 */
export function useEditActions(deps) {
    const { updateWidget, updateLayout, state, messages, setMessages, setError } = deps;

    const [pendingEdit, setPendingEdit] = useState(null);

    const handleApplyEdit = useCallback(() => {
        if (!pendingEdit) return;
        try {
            updateWidget(pendingEdit.widgetId, pendingEdit.widget);

            const lastEditMessage = [...messages].reverse().find((m) => m.edit);
            if (lastEditMessage?.edit?.layout) {
                const layouts = state.report.layout.lg || [];
                const updatedLayouts = layouts.map((item) =>
                    item.i === pendingEdit.widgetId
                        ? (lastEditMessage.edit && lastEditMessage.edit.layout) || item
                        : item
                );
                updateLayout('lg', updatedLayouts);
            }

            setPendingEdit(null);
            setMessages((prev) => [
                ...prev,
                {
                    id: `msg-${Date.now()}`,
                    role: 'assistant',
                    content: 'Panel updated successfully! Your changes have been applied.',
                    timestamp: new Date(),
                },
            ]);
        } catch (err) {
            console.error('Error applying edit:', err);
            setError('Failed to apply changes. Please try again.');
        }
    }, [pendingEdit, updateWidget, updateLayout, state.report.layout.lg, messages, setMessages, setError]);

    const handleDismissEdit = useCallback(() => {
        if (!pendingEdit) return;
        setMessages((prev) =>
            prev.map((msg) =>
                msg.edit && msg.edit.widget.id === pendingEdit.widgetId ? { ...msg, dismissed: true } : msg
            )
        );
        setPendingEdit(null);
        setMessages((prev) => [
            ...prev,
            {
                id: `msg-${Date.now()}`,
                role: 'assistant',
                content: 'No problem! Would you like to try a different edit, or create something new?',
                timestamp: new Date(),
            },
        ]);
    }, [pendingEdit, setMessages]);

    return {
        pendingEdit,
        setPendingEdit,
        handleApplyEdit,
        handleDismissEdit,
    };
}
